/**
 * The audit log.
 *
 * Read-only by construction: there is no write method here because there is no
 * write route. Entries are produced by the services that perform the actions,
 * and a client that could add one could author history.
 */

import { api } from "@/api/client";

export interface AuditEntry {
  id: string;
  action: string;
  action_display: string;
  actor_name: string;
  actor_role: string;
  approved_by_name: string;
  entity_type: string;
  entity_id: string | null;
  entity_label: string;
  reason: string;
  before: Record<string, unknown>;
  after: Record<string, unknown>;
  origin: string;
  created_at: string;
}

export interface AuditAction {
  value: string;
  label: string;
}

interface Page<T> {
  count: number;
  next: string | null;
  results: T[];
}

export const auditRepository = {
  entries: (
    params: {
      q?: string | undefined;
      action?: string | undefined;
      entity?: string | undefined;
    } = {},
  ) => {
    const query = new URLSearchParams();
    for (const [key, value] of Object.entries(params)) {
      if (value) query.set(key, value);
    }
    return api.get<Page<AuditEntry> | AuditEntry[]>(`/audit/?${query.toString()}`);
  },

  actions: () => api.get<AuditAction[]>("/audit/actions/"),
};
